import "../../../assets/scss/components/sections/home/features-4.scss";
import { Container, Image } from "react-bootstrap";

import check from "../../../assets/images/home/benefits-check.svg";
import Btn from "../../templates/button";
import feature4img from "../../../assets/images/home/feature-2.svg";

import shape1 from "../../../assets/images/home/shape-2.svg";

const Features4 = () => {
  const data = [
    {
      heading: "Professional Optimization",
      paragraph: "Tailors resumes to industry standards",
    },
    {
      heading: "AI Detection Safe",
      paragraph: "99% undetectable by AI tools",
    },
    {
      heading: "Accuracy Guaranteed",
      paragraph: "Represents you without fabrications",
    },
    {
      heading: "Smarter Over Time",
      paragraph: "Learns and improves with every use",
    },
    {
      heading: "Cutting-Edge AI",
      paragraph: "Delivers top-notch, tailored resumes",
    },
  ];
  return (
    <div className="features-4-section">
      <Container>
        <div className="features-4">
          <div className="content d-flex justify-content-between">
            <div className="right">
              <Image src={feature4img} />
              <div className="shape-1 shape">
                <Image src={shape1} />
              </div>
            </div>
            <div className="left">
              <div className="heading">
                <h3 className="heading-3">
                  Smartest AI Co-pilot for Resume Creation
                </h3>
                <p className="paragraph-small-regular">
                  Resumly's advanced AI transforms your job search
                </p>
              </div>
              <div className="features-list">
                {data.map((d, index) => (
                  <div className="list-item" key={index}>
                    <div className="list-top">
                      <div className="check">
                        <div className="icon">
                          <Image src={check} />
                        </div>
                      </div>
                      <h6 className="heading-6">{d.heading}</h6>
                    </div>
                    <div className="list-item-text">
                      <p className="paragraph-small-regular">{d.paragraph}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="learn-btn text-center text-lg-start">
                <Btn
                  text="Learn More"
                  class="btn-secondary"
                  handle={() => {
                    window.location.href =
                      process.env.REACT_APP_APP_REGISTER_URL;
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Features4;
